import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { LinkButton } from '../../shared/components';

interface Props {
  name: string;
  value: number;
  color: string;
  link?: string;
  // tooltipId?: string;
  actionOnLinkClick?: () => void;
}

const Highlight: React.FC<Props> = ({ name, value, color, link, actionOnLinkClick }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="content op-highlights">
      <div className="category">
        <div className="ohighlight">
          <div className={`circle ${color}`}>
            <div className={`inner${color === 'marine' ? `-${color}` : ''}`}>{value}</div>
          </div>
          {!link ? (
            <span>{t(name)}</span>
          ) : (
            <span>
              <LinkButton
                onClick={() => {
                  if (actionOnLinkClick) {
                    actionOnLinkClick();
                  }
                  navigate(link);
                }}
                text={t(name)}
              />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Highlight;
